import React from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';

import {
  getAppointmentsInfo,
  getDeliveryDetailsRequestResult,
  getDeliveryProducts,
} from 'features/order-tracker/store/selectors';
import { ServiceInfoComponent } from './components';
import { APPOINTMENT, DELIVERY } from './constants';

import styles from './styles.module.scss';

export const DeliveriesAndAppointments: React.FC = () => {
  const {
    engineerAppointmentsCount,
    completedEngineerAppointmentsCount,
  } = useSelector(getAppointmentsInfo);
  const { totalDeliveryProducts, sentDeliveryProducts } = useSelector(getDeliveryProducts);
  const isDeliveryDetailsFailed = useSelector(getDeliveryDetailsRequestResult);
  const isEmptyBlock = !isDeliveryDetailsFailed && !engineerAppointmentsCount && !totalDeliveryProducts;

  return (
    <div className={classNames(styles.servicesContainer, { [styles.emptyBlock]: isEmptyBlock })}>
      <ServiceInfoComponent
        type={DELIVERY}
        totalCount={totalDeliveryProducts}
        completedCount={sentDeliveryProducts}
        error={isDeliveryDetailsFailed}
      />
      <ServiceInfoComponent
        type={APPOINTMENT}
        totalCount={engineerAppointmentsCount}
        completedCount={completedEngineerAppointmentsCount}
      />
    </div>
  );
};
